// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1qY3i","head":"ProcedureTableInfo_head__3CF0C"};